package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun MagnificentMansionMetadata() {
    SpellMetadata(
        spellIndex = "magnificent-mansion",
        castingTime = "1 minute",
        range = "300 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A miniature portal carved from ivory, a small piece of polished marble, and a tiny silver spoon, each item worth at least 5 gp.",
        duration = "24 hours",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = "5-ft Cube",
        concentration = false
    )
}
